export default {
    crop: {
        title: "Raccolto",
        cropSize: "Dimensione del raccolto",
        zoom: "Zoom",
        custom: 'Personalizzato',
        post: 'Post',
        square: 'Quadrato',
        landscape: 'Paesaggio',
        story: 'Storia',
        portrait: 'Ritratto',
        carousel: 'Carosello',
        commonAspectRatio: "Rapporto d'aspetto comune",
    },
};
